import { List, ListItem, makeStyles, Typography } from "@material-ui/core";
import { ErrorBoundary } from "@common/error-boundary";
import { SpinnerOverlay, WithTooltip } from "@common";
import React from "react";
import locale from "@bonliva-crm/locale";
import { DocItem } from "./booking-kit-profile-layout";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

type Props = {
  activeDocLink: string;
  docs: DocItem[];
  setActiveDocLink: (url: string) => void;
};

export const BookingKitDocPreview = ({
  activeDocLink,
  docs,
  setActiveDocLink
}: Props) => {
  const classes = useStyles();

  return (
    <ErrorBoundary>
      <div>
        <List aria-label="menu" className={classes.list}>
          {docs?.map((x) => (
            <ListItem
              style={{ overflow: "hidden", maxWidth: 200 }}
              key={x.id}
              button
              selected={activeDocLink?.includes(x.link)}
              onClick={(e) => setActiveDocLink(x.link)}
            >
              <div className={classes.docTitleWrap}>
                <WithTooltip placement={"top"} title={x.title}>
                  <Typography noWrap>{x.title}</Typography>
                </WithTooltip>
                <OpenInNewIcon
                  color={"primary"}
                  fontSize={"small"}
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(x.link);
                  }}
                />
              </div>
            </ListItem>
          ))}
        </List>
      </div>
      <div className={classes.root}>
        {activeDocLink ? (
          <>
            <SpinnerOverlay show={true} style={{ zIndex: 1, position: "absolute" }} />
            <iframe src={activeDocLink} className={classes.iframe} />
          </>
        ) : (
          <Typography variant={"h5"} align={"center"}>
            {locale.ChooseField(locale.Kit)}
          </Typography>
        )}
      </div>
    </ErrorBoundary>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "90vh"
  },
  docTitleWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  iframe: {
    position: "relative",
    height: "90vh",
    border: 0,
    flex: 1,
    zIndex: 10,
    width: "100%"
  },
  list: {
    display: "flex",
    flexWrap: "wrap"
  }
}));
